// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__25SWG","label":"LabeledBox_label__19p7Z"};